/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './entities-assignment.scss';

/* eslint-disable import/no-unresolved, import/default */

import entitiesAssignmentTemplate from './entities-assignment.tpl.html';
import entitiesAssignDialogTemplate from './entities-assign-dialog.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.admin.entitiesAssignment', [])
    .directive('agEntitiesAssignment', EntitiesAssignment)
    .name;

/*@ngInject*/
function EntitiesAssignment() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '='
        },
        controller: EntitiesAssignmentController,
        controllerAs: 'vm',
        templateUrl: entitiesAssignmentTemplate
    };
}

/* eslint-disable angular/angularelement */

/*@ngInject*/
function EntitiesAssignmentController($scope, $q, $filter, $mdDialog, $translate, $document, types, agTypes, toast,
                                      entityService, userService, entityRelationService, agDeviceService) {// eslint-disable-line

    let vm = this;

    vm.types = types;
    vm.showData = userService.getAuthority() === 'TENANT_ADMIN';
    vm.loading = false;

    vm.entityTypes = [{
        label: "entity.type-devices",
        value: types.entityType.device
    },{
        label: "entity.type-assets",
        value: types.entityType.asset
    }];

    vm.relationTypes = {};
    vm.relationTypes[types.entityRelationType.contains] = {
        name: types.entityRelationType.contains,
        disabled: false
    };
    vm.relationTypes[agTypes.relationType.aerationSystem] = {
        name: agTypes.relationType.aerationSystem,
        disabled: false
    };
    vm.relationTypes[agTypes.relationType.weatherStation] = {
        name: agTypes.relationType.weatherStation,
        disabled: false
    };
    vm.currentRelationType = vm.relationTypes[types.entityRelationType.contains];

    vm.entitiesTo = [];
    vm.allEntitiesTo = [];
    vm.selectedEntitiesTo = [];

    vm.entitiesFrom = [];
    vm.allEntitiesFrom = [];
    vm.selectedEntitiesFrom = [];

    vm.assignedEntities = [];

    vm.entityTypeTo = types.entityType.device;
    vm.entityTypeFrom = types.entityType.asset;

    vm.queryTo = {
        order: 'name',
        limit: 5,
        page: 1,
        search: null
    };

    vm.queryFrom = {
        order: 'name',
        limit: 5,
        page: 1,
        search: null
    };

    vm.reloadEntitiesTo = reloadEntitiesTo;
    vm.reloadEntitiesFrom = reloadEntitiesFrom;
    vm.enterFilterModeTo = enterFilterModeTo;
    vm.enterFilterModeFrom = enterFilterModeFrom;
    vm.exitFilterModeTo = exitFilterModeTo;
    vm.exitFilterModeFrom = exitFilterModeFrom;
    vm.onReorderTo = onReorderTo;
    vm.onReorderFrom = onReorderFrom;
    vm.assignEntities = assignEntities;
    vm.multiSelectShiftClick = multiSelectShiftClick;

    $scope.$watch('vm.ctx', function () {
        if (vm.showData && vm.ctx) {
            reloadEntitiesTo();
            reloadEntitiesFrom();
        }
    });

    $scope.$watch("vm.queryTo.search", (newVal, prevVal) => {
        if (!angular.equals(newVal, prevVal) && vm.queryTo.search != null) {
            updateEntitiesTo();
        }
    });

    $scope.$watch("vm.queryFrom.search", (newVal, prevVal) => {
        if (!angular.equals(newVal, prevVal) && vm.queryFrom.search != null) {
            updateEntitiesFrom();
        }
    });

    $scope.$watchCollection('vm.selectedEntitiesTo', () => {
        validateRelationTypes();
    });

    $scope.$watchCollection('vm.selectedEntitiesFrom', () => {
        disableHighlightingEntities();
        validateRelationTypes();
        highlightRelatedEntities();
    });


    function enterFilterModeTo() {
        vm.queryTo.search = '';
    }

    function enterFilterModeFrom() {
        vm.queryFrom.search = '';
    }

    function exitFilterModeTo() {
        vm.queryTo.search = null;
        updateEntitiesTo();
    }

    function exitFilterModeFrom() {
        vm.queryFrom.search = null;
        updateEntitiesFrom();
    }

    function onReorderTo() {
        updateEntitiesTo();
    }
    function onReorderFrom() {
        updateEntitiesFrom();
    }

    function reloadEntitiesTo() {
        vm.entitiesTo = [];
        vm.allEntitiesTo = [];
        if (vm.entityTypeTo === types.entityType.device) {
            vm.entitiesPromiseTo = agDeviceService.getAllDevices();
        } else if (vm.entityTypeTo === types.entityType.asset) {
            vm.entitiesPromiseTo = getAllAssets();
        }
        vm.entitiesPromiseTo.then(
            (allEntities) => {
                let filteredEntities;
                if (vm.entityTypeTo === types.entityType.device) {
                    filteredEntities = allEntities.filter(device => device.type === agTypes.deviceType.temperatureSensorLines ||
                        device.type === agTypes.deviceType.moistureSensorLines ||
                        device.type === agTypes.deviceType.co2SensorLines ||
                        device.type === agTypes.deviceType.levelIndicator ||
                        device.type === agTypes.deviceType.headSpaceSensor ||
                        device.type === agTypes.deviceType.weatherStation);
                } else if (vm.entityTypeTo === types.entityType.asset) {
                    filteredEntities = allEntities.filter(asset => asset.type === agTypes.assetType.site ||
                        asset.type === agTypes.assetType.siloGroup ||
                        asset.type === agTypes.assetType.silo ||
                        asset.type === agTypes.assetType.aeration ||
                        asset.type === agTypes.assetType.weatherStation);
                }
                vm.allEntitiesTo = filteredEntities;
                vm.selectedEntitiesTo = [];
                updateEntitiesTo();
                vm.entitiesPromiseTo = null;
                highlightRelatedEntities();
            },
            () => {
                vm.allEntitiesTo = [];
                vm.selectedEntitiesTo = [];
                updateEntitiesTo();
                vm.entitiesPromiseTo = null;
            }
        );
    }

    function reloadEntitiesFrom() {
        vm.entitiesFrom = [];
        vm.allEntitiesFrom = [];
        if (vm.entityTypeFrom === types.entityType.device) {
            vm.entitiesPromiseFrom = agDeviceService.getAllDevices();
        } else if (vm.entityTypeFrom === types.entityType.asset) {
            vm.entitiesPromiseFrom = getAllAssets();
        }
        vm.entitiesPromiseFrom.then(
            (allEntities) => {
                let filteredEntities;
                if (vm.entityTypeFrom === types.entityType.device) {
                    filteredEntities = allEntities.filter(device => device.type === agTypes.deviceType.temperatureSensorLines ||
                        device.type === agTypes.deviceType.moistureSensorLines ||
                        device.type === agTypes.deviceType.co2SensorLines ||
                        device.type === agTypes.deviceType.levelIndicator ||
                        device.type === agTypes.deviceType.headSpaceSensor ||
                        device.type === agTypes.deviceType.weatherStation);
                } else if (vm.entityTypeFrom === types.entityType.asset) {
                    filteredEntities = allEntities.filter(asset => asset.type === agTypes.assetType.site ||
                        asset.type === agTypes.assetType.siloGroup ||
                        asset.type === agTypes.assetType.silo ||
                        asset.type === agTypes.assetType.aeration ||
                        asset.type === agTypes.assetType.weatherStation);
                }
                vm.allEntitiesFrom = filteredEntities;
                vm.selectedEntitiesFrom = [];
                updateEntitiesFrom();
                vm.entitiesPromiseFrom = null;
            },
            () => {
                vm.allEntitiesFrom = [];
                vm.selectedEntitiesFrom = [];
                updateEntitiesFrom();
                vm.entitiesPromiseFrom = null;
            }
        );
    }

    function updateEntitiesTo() {
        vm.selectedEntitiesTo = [];
        let result = $filter('orderBy')(vm.allEntitiesTo, vm.queryTo.order);
        if (vm.queryTo.search != null) {
            result = $filter('filter')(result, {$: vm.queryTo.search});
        }
        vm.entitiesTo = result;
    }

    function updateEntitiesFrom() {
        vm.selectedEntitiesFrom = [];
        let result = $filter('orderBy')(vm.allEntitiesFrom, vm.queryFrom.order);
        if (vm.queryFrom.search != null) {
            result = $filter('filter')(result, {$: vm.queryFrom.search});
        }
        vm.entitiesFrom = result;
    }

    function assignEntities() {
        vm.loading = true;
        let existingEntitiesRelationTasks = [];
        for (let i = 0; i < vm.selectedEntitiesTo.length; i++) {
            existingEntitiesRelationTasks.push(entityRelationService.findByTo(vm.selectedEntitiesTo[i].id.id, vm.selectedEntitiesTo[i].id.entityType));
        }
        $q.all(existingEntitiesRelationTasks).then(
            (existingRelationsData) => {
                let isExistingFlag;
                for (let i = 0; i < vm.selectedEntitiesTo.length; i++) {
                    vm.selectedEntitiesTo[i].existingRelations = existingRelationsData[i];
                    if (existingRelationsData[i].length) {
                        isExistingFlag = true;
                    }
                }
                if (isExistingFlag) {
                    vm.loading = false;
                    $mdDialog.show({
                        controller: entitiesAssignDialogController,
                        controllerAs: 'vm',
                        templateUrl: entitiesAssignDialogTemplate,
                        parent: angular.element($document[0].body),
                        locals: {
                            selectedEntitiesTo: vm.selectedEntitiesTo,
                            selectedEntitiesFrom: vm.selectedEntitiesFrom,
                            currentRelationType: vm.currentRelationType
                        },
                        fullscreen: true,
                        skipHide: true
                    }).then(() => {
                        vm.selectedEntitiesFrom = [];
                        vm.selectedEntitiesTo = [];
                        exitFilterModeTo();
                        exitFilterModeFrom();
                        toast.showSuccess("Selected entities were successfully assigned!", 1000, vm.ctx.$container, 'top left');
                    });
                } else {
                    let entitiesRelationTasks = [];
                    for (let i = 0; i < vm.selectedEntitiesTo.length; i++) {
                        let newRelation = {
                            from: vm.selectedEntitiesFrom[0].id,
                            to: vm.selectedEntitiesTo[i].id,
                            type: vm.currentRelationType.name
                        };
                        entitiesRelationTasks.push(entityRelationService.saveRelation(newRelation));
                    }
                    $q.all(entitiesRelationTasks).then(
                        () => {
                            vm.loading = false;
                            vm.selectedEntitiesFrom = [];
                            vm.selectedEntitiesTo = [];
                            exitFilterModeTo();
                            exitFilterModeFrom();
                            toast.showSuccess("Selected entities were successfully assigned!", 1000, vm.ctx.$container, 'top left');
                        },
                        () => {
                            vm.loading = false;
                        }
                    );
                }
            },
            () => {
                vm.loading = false;
            }
        );
    }

    function multiSelectShiftClick(e, index) {
        if (e.shiftKey){
            let checkedFlag = false;
            let selectedEntities = [];
            for (let i = index - 1; i >= 0; i--) {
                let entity = vm.entitiesTo[i];
                if (vm.selectedEntitiesTo.indexOf(entity) === -1) {
                    selectedEntities.push(entity);
                } else {
                    vm.selectedEntitiesTo = vm.selectedEntitiesTo.concat(selectedEntities);
                    checkedFlag = true;
                    break;
                }
            }
            if (!checkedFlag) {
                selectedEntities = [];
                for (let i = index + 1; i < vm.entitiesTo.length; i++) {
                    let entity = vm.entitiesTo[i];
                    if (vm.selectedEntitiesTo.indexOf(entity) === -1) {
                        selectedEntities.push(entity);
                    } else {
                        vm.selectedEntitiesTo = vm.selectedEntitiesTo.concat(selectedEntities);
                        break;
                    }
                }
            }
        }
    }

    function validateRelationTypes() {
        enableAllRelationTypes();
        if (vm.selectedEntitiesTo.length && !vm.selectedEntitiesFrom.length) {
            if (vm.entityTypeTo === types.entityType.asset) {
                let siteRes = vm.selectedEntitiesTo.filter(asset => asset.type === agTypes.assetType.site);
                let siloRes = vm.selectedEntitiesTo.filter(asset => asset.type === agTypes.assetType.silo);
                let weatherRes = vm.selectedEntitiesTo.filter(asset => asset.type === agTypes.assetType.weatherStation);
                if (siteRes.length) {// 1) если пикнут хоть один сайт - блокируем всё + underfined
                    disabledAllRelations();
                    vm.currentRelationType = null;
                } else if (siloRes.length === vm.selectedEntitiesTo.length) {// 2) если только силосы - доступны contains && aeration
                    vm.relationTypes[agTypes.relationType.weatherStation].disabled = true;
                    vm.currentRelationType = vm.relationTypes[types.entityRelationType.contains];
                } else if (weatherRes.length === vm.selectedEntitiesTo.length) {// 3) если только weather - доступны contains && weather
                    vm.relationTypes[agTypes.relationType.aerationSystem].disabled = true;
                    vm.currentRelationType = vm.relationTypes[types.entityRelationType.contains];
                } else {// 4) всё остальное - только contains
                    setOnlyContains();
                }
            } else if (vm.entityTypeTo === types.entityType.device) {
                let wshtRes = vm.selectedEntitiesTo.filter(device => device.type === agTypes.deviceType.weatherStation);
                if (wshtRes.length && wshtRes.length !== vm.selectedEntitiesTo.length) {// 1) если кроме WSHT пикнуты и другие типы - блокируем всё + underfined
                    disabledAllRelations();
                    vm.currentRelationType = null;
                } else {// 2) все остальное - contains
                    setOnlyContains();
                }
            }
        } else if (vm.selectedEntitiesFrom.length && !vm.selectedEntitiesTo.length) {
            if (vm.entityTypeFrom === types.entityType.asset) {
                if (vm.selectedEntitiesFrom[0].type === agTypes.assetType.aeration) {// 1) если пикнут aeration - доступны aeration && weather
                    vm.relationTypes[types.entityRelationType.contains].disabled = true;
                    vm.currentRelationType = vm.relationTypes[agTypes.relationType.aerationSystem];
                } else {// 2) если пикнут silo/silogroup/site/weather - только contains
                    setOnlyContains();
                }
            } else if (vm.entityTypeFrom === types.entityType.device) {//  блокируем всё + underfined
                disabledAllRelations();
                vm.currentRelationType = null;
            }
        } else if (vm.selectedEntitiesTo.length && vm.selectedEntitiesFrom.length) {
            if (vm.entityTypeTo === types.entityType.asset && vm.entityTypeFrom === types.entityType.asset) {
                let siteRes = vm.selectedEntitiesTo.filter(asset => asset.type === agTypes.assetType.site);
                let siloRes = vm.selectedEntitiesTo.filter(asset => asset.type === agTypes.assetType.silo);
                let siloGroupRes = vm.selectedEntitiesTo.filter(asset => asset.type === agTypes.assetType.siloGroup);
                let weatherRes = vm.selectedEntitiesTo.filter(asset => asset.type === agTypes.assetType.weatherStation);
                if (siteRes.length) {// 1) если пикнут хоть один сайт - блокируем всё + underfined
                    disabledAllRelations();
                    vm.currentRelationType = null;
                } else if (siloRes.length === vm.selectedEntitiesTo.length) {// 2) если пикнуты только силосы:
                    if (vm.selectedEntitiesFrom[0].type === agTypes.assetType.site || vm.selectedEntitiesFrom[0].type === agTypes.assetType.siloGroup) {// a) если папа site/silogroup - только contains
                        setOnlyContains();
                    } else if (vm.selectedEntitiesFrom[0].type === agTypes.assetType.aeration) {// b) если папа aeration  - только aeration
                        disabledAllRelations();
                        vm.relationTypes[agTypes.relationType.aerationSystem].disabled = false;
                        vm.currentRelationType = vm.relationTypes[agTypes.relationType.aerationSystem];
                    } else {// c) всё остальное - блокируем всё + underfined
                        disabledAllRelations();
                        vm.currentRelationType = null;
                    }
                } else if (weatherRes.length === vm.selectedEntitiesTo.length) {// 3) если пикнуты только weather:
                    if (vm.selectedEntitiesFrom[0].type === agTypes.assetType.site || vm.selectedEntitiesFrom[0].type === agTypes.assetType.siloGroup) {// a) если папа site/silogroup - только contains
                        setOnlyContains();
                    } else if (vm.selectedEntitiesFrom[0].type === agTypes.assetType.aeration) {// b) если папа aeration  - только weather
                        disabledAllRelations();
                        vm.relationTypes[agTypes.relationType.weatherStation].disabled = false;
                        vm.currentRelationType = vm.relationTypes[agTypes.relationType.weatherStation];
                    } else {// c) всё остальное - блокируем всё + underfined
                        disabledAllRelations();
                        vm.currentRelationType = null;
                    }
                } else { // 4) всё остальное:
                    if (siloGroupRes.length) {// a) если пикнут хотябы один silogroup:
                        if (vm.selectedEntitiesFrom[0].type === agTypes.assetType.site) {// 1) если папа site - только contains
                            setOnlyContains();
                        } else {// 2) всё остальное - блокируем всё + underfined
                            disabledAllRelations();
                            vm.currentRelationType = null;
                        }
                    } else {// b) все остальное:
                        if (vm.selectedEntitiesFrom[0].type === agTypes.assetType.site || vm.selectedEntitiesFrom[0].type === agTypes.assetType.siloGroup) {// 1) если папа site/siloGroup - только contains
                            setOnlyContains();
                        } else {// 2) всё остальное - блокируем всё + underfined
                            disabledAllRelations();
                            vm.currentRelationType = null;
                        }
                    }
                }
            } else if (vm.entityTypeTo === types.entityType.device && vm.entityTypeFrom === types.entityType.asset) {// eslint-disable-line
                let wshtRes = vm.selectedEntitiesTo.filter(device => device.type === agTypes.deviceType.weatherStation);
                if (wshtRes.length === vm.selectedEntitiesTo.length) {// 1) если пикнуты только WSHT:
                    if (vm.selectedEntitiesFrom[0].type === agTypes.assetType.weatherStation) {// a) если папа weather - только contains
                        setOnlyContains();
                    } else {// b) всё остальное - блокируем всё + underfined
                        disabledAllRelations();
                        vm.currentRelationType = null;
                    }
                } else if (!wshtRes.length) { // 2) если среди пикнутого нет WSHT:
                    if (vm.selectedEntitiesFrom[0].type === agTypes.assetType.silo) {// a) если папа silo - только contains
                        setOnlyContains();
                    } else {// b) всё остальное - блокируем всё + underfined
                        disabledAllRelations();
                        vm.currentRelationType = null;
                    }
                } else {// 3) все остальное - блокируем всё + underfined
                    disabledAllRelations();
                    vm.currentRelationType = null;
                }
            } else { // блокируем всё + underfined
                disabledAllRelations();
                vm.currentRelationType = null;
            }
        } else {
            enableAllRelationTypes();
            vm.currentRelationType = vm.relationTypes[types.entityRelationType.contains];
        }
    }

    function enableAllRelationTypes() {
        for (let key in vm.relationTypes) {
            vm.relationTypes[key].disabled = false;
        }
    }

    function disabledAllRelations() {
        for (let key in vm.relationTypes) {
            vm.relationTypes[key].disabled = true;
        }
    }

    function setOnlyContains() {
        disabledAllRelations();
        vm.relationTypes[types.entityRelationType.contains].disabled = false;
        vm.currentRelationType = vm.relationTypes[types.entityRelationType.contains];
    }

    function highlightRelatedEntities() {
        if (vm.entityTypeFrom === types.entityType.asset && vm.selectedEntitiesFrom.length) {
            vm.loading = true;
            entityRelationService.findByFrom(vm.selectedEntitiesFrom[0].id.id, vm.selectedEntitiesFrom[0].id.entityType).then(
                (relationsData) => {
                    vm.assignedEntities = relationsData.map(ralation => ralation.to);
                    for (let i = 0; i < vm.assignedEntities.length; i++) {
                        for (let j = 0; j < vm.allEntitiesTo.length; j++) {
                           if (vm.assignedEntities[i].id === vm.allEntitiesTo[j].id.id) {
                               vm.allEntitiesTo[j].highlight = true;
                               break;
                           }
                        }
                    }
                    vm.loading = false;
                },
                () => {
                    vm.loading = false;
                }
            );
        }
    }

    function disableHighlightingEntities() {
        vm.allEntitiesTo.forEach((entity) => {
            entity.highlight = false;
        });
    }

    function getAllAssets() {
        let deferred = $q.defer();
        entityService.getEntitiesByNameFilter(types.entityType.asset, '', -1).then(
            (assets) => {
                if (assets) {
                    assets.forEach((asset) => {
                        asset.typeName = $translate.instant(agTypes.assetTypeTranslatePrefix+'.'+asset.type);
                    });
                    deferred.resolve(assets);
                } else {
                    deferred.reject();
                }
            },
            () => {
                deferred.reject();
            }
        );
        return deferred.promise;
    }
}

/*@ngInject*/
function entitiesAssignDialogController($q, $mdDialog, types, agTypes, entityService, entityRelationService,
                                        selectedEntitiesTo, selectedEntitiesFrom, currentRelationType) {// eslint-disable-line
    var vm = this;

    vm.agTypes = agTypes;
    vm.loading = true;

    let parentAssetsIds = [];
    for (let i = 0; i < selectedEntitiesTo.length; i++) {
        for (let j = 0; j < selectedEntitiesTo[i].existingRelations.length; j++) {
            if (!parentAssetsIds.some(id => id === selectedEntitiesTo[i].existingRelations[j].from.id)) {
                parentAssetsIds.push(selectedEntitiesTo[i].existingRelations[j].from.id);
            }
        }
    }
    entityService.getEntities(types.entityType.asset, parentAssetsIds).then(
        (parentAssets) => {
            for (let i = 0; i < selectedEntitiesTo.length; i++) {
                selectedEntitiesTo[i].relatedParents = [];
                for (let j = 0; j < selectedEntitiesTo[i].existingRelations.length; j++) {
                    let result = parentAssets.find(parent => parent.id.id === selectedEntitiesTo[i].existingRelations[j].from.id);
                    selectedEntitiesTo[i].relatedParents.push(result);
                }
            }
            vm.selectedEntitiesTo = selectedEntitiesTo;
            vm.loading = false;
        },
        () => {
            vm.loading = false;
        }
    );

    vm.cancel = cancel;
    vm.assign = assign;
    vm.assignAndBreakOldRelations = assignAndBreakOldRelations;

    function assign() {
        vm.loading = true;
        let entitiesRelationTasks = [];
        for (let i = 0; i < vm.selectedEntitiesTo.length; i++) {
            let newRelation = {
                from: selectedEntitiesFrom[0].id,
                to: vm.selectedEntitiesTo[i].id,
                type: currentRelationType.name
            };
            entitiesRelationTasks.push(entityRelationService.saveRelation(newRelation));
        }
        $q.all(entitiesRelationTasks).then(
            () => {
                vm.loading = false;
                $mdDialog.hide();
            },
            () => {
                vm.loading = false;
            }
        )
    }

    function assignAndBreakOldRelations() {
        vm.loading = true;
        let removeRelationTasks = [];
        for (let i = 0; i < vm.selectedEntitiesTo.length; i++) {
            for (let j = 0; j < selectedEntitiesTo[i].existingRelations.length; j++) {
                let relation = selectedEntitiesTo[i].existingRelations[j];
                removeRelationTasks.push(entityRelationService.deleteRelation(relation.from.id, relation.from.entityType, relation.type, relation.to.id, relation.to.entityType));
            }
        }
        $q.all(removeRelationTasks).then(
            () => {
                assign();
            },
            () => {
                vm.loading = false;
            }
        );
    }

    function cancel() {
        $mdDialog.cancel();
    }
}